import { IClientProductGateway, MapProductInput, PresenterFunc } from '@/core/interface';
import { ClientProduct } from '@/core/entity';
import { Fragment, UpdaterFunc } from '@/core/interface/common';

export class MapClientProduct {
  constructor(
    private readonly clientProductGw: IClientProductGateway,
  ) { }

  public async execute(
    input: MapProductInput,
    presenter: PresenterFunc<ClientProduct | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {

      const result = await this.clientProductGw.mapProduct(input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
